import { Injectable } from "@angular/core";
import { HttpClient } from '@angular/common/http';
import { RespApiAlerta } from "../model/AuthApiAlerta";
import { ParamApiAlerta } from "../../modulos/portal/telas/alerta-monitoramento/paramApiAlerta";
import { DefaultHttpService } from "../../modulos/portal/telas/alerta-monitoramento/default-http.service";

@Injectable()
export class AuthApiAlertaHttpService extends DefaultHttpService<RespApiAlerta> {
  constructor(
    public httpClient: HttpClient,
  ) {
    super(
      httpClient,
			`${ParamApiAlerta.getUrl()}/auth`,
    );
  }
}


// WEBPACK FOOTER //
// ./src/app/commons/servicos/AuthApiAlertaHttp.service.ts